import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import {
  API_KEY_LIST,
  CREATE_API_KEY,
  DETAIL_API_KEY,
  DELETE_API_KEY,
  UPDATE_API_KEY,
} from "../actions/api-key.actions.types";

const call = Effects.call;

function* getApiKeyList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "api-keys/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* apiKeyDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `api-keys/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* addApiKey({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "api-keys",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* updateApiKey({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `api-keys/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteApiKey({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `api-keys/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* ApiKey() {
  yield all([
    takeLatest(API_KEY_LIST, getApiKeyList),
    takeLatest(DETAIL_API_KEY, apiKeyDetails),
    takeLatest(CREATE_API_KEY, addApiKey),
    takeLatest(UPDATE_API_KEY, updateApiKey),
    takeLatest(DELETE_API_KEY, deleteApiKey),
  ]);
}

export default ApiKey;
